import { render, staticRenderFns } from "./BenefitsGrid.vue?vue&type=template&id=13a138da&scoped=true&"
import script from "./BenefitsGrid.vue?vue&type=script&lang=js&"
export * from "./BenefitsGrid.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsGrid.vue?vue&type=style&index=0&id=13a138da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a138da",
  null
  
)

export default component.exports